import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=ed483aca&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"
import style0 from "./notice.vue?vue&type=style&index=0&id=ed483aca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed483aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed483aca')) {
      api.createRecord('ed483aca', component.options)
    } else {
      api.reload('ed483aca', component.options)
    }
    module.hot.accept("./notice.vue?vue&type=template&id=ed483aca&scoped=true", function () {
      api.rerender('ed483aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/notice/notice.vue"
export default component.exports